import React, {
  FunctionComponent,
  useState,
  ChangeEvent,
  useCallback,
  useEffect,
} from 'react';
import { InputProps, Input } from '../index';
import { maskSsn } from './SsnInput.util';

export const SsnInput: FunctionComponent<InputProps> = props => {
  const { onChange, value, ...restOfProps } = props;
  const [ssn, setSsn] = useState(value || '');
  const maskedSsn = maskSsn(ssn);

  useEffect(() => {
    if (value !== ssn) {
      setSsn(value!);
    }
  }, [value, ssn]);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      let newSsn;
      const prevValue = maskedSsn;
      const newValue = e.target.value;

      if (newValue.length > 11) {
        // max length is 11
        return;
      } else if (newValue.length > prevValue.length) {
        // typing or pasting
        const numberOfNewCharacters = newValue.length - prevValue.length;
        newSsn = `${ssn}${newValue.slice(-numberOfNewCharacters)}`;
      } else {
        // backspacing / deleting
        const numberOfRemovedCharacters = prevValue.length - newValue.length;
        newSsn = ssn.substr(0, ssn.length - numberOfRemovedCharacters);
      }

      newSsn = newSsn.replace(/[\D]/g, '');

      setSsn(newSsn);

      if (onChange) onChange(newSsn);
    },
    [ssn, maskedSsn, onChange],
  );

  return <Input {...restOfProps} value={maskedSsn} onChange={handleChange} />;
};
